import { type StaffRole, staffRoleRowSchema } from '@noconflict/contracts';
import type { Supabase } from '../../shared/api/supabase';

/**
 * The caller's own staff roles. RLS shows a person their own rows at any assurance level, so the `/admin` gate
 * can tell staff from customers before asking for the second factor. Empty for every customer.
 */
export async function listOwnStaffRoles(client: Supabase, userId: string): Promise<StaffRole[]> {
  const { data, error } = await client.from('staff_roles').select('*').eq('user_id', userId);
  if (error) throw new Error(error.message);
  return staffRoleRowSchema
    .array()
    .parse(data)
    .map((row) => row.role);
}
